var $431fbd86ca7dc216$export$b204af158042fbac = function $431fbd86ca7dc216$export$b204af158042fbac(el) {
  var _el_ownerDocument;
  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
var $431fbd86ca7dc216$export$f21a1ffae260145a = function $431fbd86ca7dc216$export$f21a1ffae260145a(el) {
  if (el && 'window' in el && el.window === el) return el;
  var doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
  return doc.defaultView || window;
};
export { $431fbd86ca7dc216$export$b204af158042fbac as getOwnerDocument, $431fbd86ca7dc216$export$f21a1ffae260145a as getOwnerWindow };